
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"10","height":"10"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 0h10v10H0z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"fill":"#6D7587","fill-rule":"nonzero","d":"M5.625.625v3.75h3.75v1.25h-3.75v3.75h-1.25v-3.75H.625v-1.25h3.75V.625z","mask":"url(#b)","transform":"rotate(45 5 5)"}})])])
          )
        }
      }
    